var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.content_js),expression:"content_js"}],attrs:{"id":_vm.id_js},domProps:{"value":(_vm.content_js)},on:{"input":function($event){if($event.target.composing)return;_vm.content_js=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }